<script type="text/javascript">
  export default {
  };
</script>

<template>
  <div class="market-loader">
    <div class="market-loader__data">
    </div>
  </div>
</template>

<style lang="scss">
  .market-loader {
    background: linear-gradient(307deg, #07414b, #083037);
    height: 172px;
    margin-bottom: 10px;
    background-size: cover;
    border-radius: 4px;
    padding-top: 8px;

    &__data {
      height: 160px;
      width: 180px;
      background: url('~assets/images/transition/market-block.svg');
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketLoader.vue